import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.content-with-media-carousel-swiper').forEach((element) => {
    new Swiper(element, {
      modules: [Navigation, Pagination, Autoplay, A11y],
      slidesPerView: 1,
      spaceBetween: 2,
      simulateTouch: false,
      navigation: {
        enabled: element.dataset.navigation == '1',
        prevEl: element.closest('.swiper-parent').querySelector('.swiper-navigation .prev'),
        nextEl: element.closest('.swiper-parent').querySelector('.swiper-navigation .next'),
      },
      pagination: {
        enabled: element.dataset.pagination == '1',
        el: element.closest('.swiper-parent').querySelector('.swiper-pagination'),
        clickable: true,
        bulletActiveClass: 'swiper-pagination-numeric-active',
        bulletClass: 'swiper-pagination-numeric',
        renderBullet: (index, className) => {
          return '<span class="' + className + '">' + String(index + 1).padStart(2, '0') + "</span>";
        },
      },
      loop: element.dataset.loop == '1',
      autoplay: element.dataset.autoplay == '1'
        ? {
            delay: parseFloat(element.dataset.autoplayDelay) * 1000,
          }
        : false,
      on: {
        slideChangeTransitionEnd: (swiper) => {
          swiper.el.querySelectorAll('.swiper-slide:not(.swiper-slide-active) .content-with-media-video-container').forEach((videoContainer) => {
            videoContainer?.stopVideo();
          });
        }
      }
    });
  });
});
